import Box from '@mui/material/Box'
import React from 'react'

const DividerWithTextCust = ({
  children,
  width,
  colorDivider,
  left,
  right,
  padLeft,
  padRight,
  weight,
  colorText,
  fs,
}: {
  children: React.ReactNode
  width: number
  colorDivider: string
  left: number
  right: number
  padLeft: string
  padRight: string
  weight: number
  colorText: string
  fs: number
}) => {
  return (
    <Box display={'flex'} alignItems={'baseline'} justifyContent={'flex-start'}>
      <Box borderBottom={`${width}px solid ${colorDivider}`} width={`${left}%`} />

      <span
        style={{
          paddingTop: '1em',
          paddingBottom: '1em',
          paddingRight: `${padRight}`,
          paddingLeft: `${padLeft}`,
          fontWeight: `${weight}`,
          fontSize: fs,
          color: `${colorText}`,
        }}
      >
        {children}
      </span>

      <Box borderBottom={`${width}px solid ${colorDivider}`} width={`${right}%`} />
    </Box>
  )
}
export default DividerWithTextCust
